import React, { useEffect } from 'react';

import { Form, Input } from 'antd';
import { openUrl } from '@whelk/utils';
import { LOGIN_TYPE } from '@whelk/services/src/user';
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from '@whelk/assets/src/web/common-icons';

import useLogin from '../../hooks/useLogin';
import { PHONE_LENGTH } from '../../constants';
import Button from '../../../../../../Base/Button';

import './index.scss';
import SendCodeBtn from '../SendCodeBtn';
import { privacyPolicyUrl, termsOfServiceUrl } from '@whelk/const';

const LoginFormComponent = ({ loginType }: { loginType: LOGIN_TYPE }) => {
  const [form] = Form.useForm();
  const {
    checked,
    setChecked,
    onFinish,
    openAppealModal,
    phoneValid,
    handlePhoneChange,
    formTemporary,
  } = useLogin();

  const onSubmit = () => {
    const { phone, code } = form.getFieldsValue();
    onFinish({ phone, code }, loginType);
  };

  const handleAppealModal = () => {
    const phone = form.getFieldValue('phone');
    openAppealModal(phone);
  };

  useEffect(() => {
    if (formTemporary) {
      form.setFieldsValue(formTemporary);
    }
  }, [formTemporary]);

  return (
    // 验证码登录表单
    <Form form={form}>
      <div className=' phone-wrap mb-[12px] flex rounded-[12px]'>
        <Form.Item
          name='phone'
          getValueFromEvent={(e) => e?.target?.value?.replace(/\D/g, '')}
          className='flex-1'
        >
          <Input
            maxLength={PHONE_LENGTH}
            placeholder='请输入手机号'
            autoComplete='off'
            onChange={handlePhoneChange}
            className='bg-col_bg09 border-col_line00 text-col_text00 rounded-[12px] border px-4 py-[13px] text-[16px] leading-[22px] placeholder:text-[16px] placeholder:text-[#999] focus:shadow-none '
            autoFocus={true}
          />
        </Form.Item>
      </div>

      <div className='border-col_line00 flex w-full  items-center overflow-hidden rounded-[12px] border'>
        <div className='flex-1'>
          <Form.Item
            name='code'
            className='mb-0'
            getValueFromEvent={(e) => e?.target?.value?.replace(/\D/g, '')}
          >
            <Input
              size='large'
              maxLength={6}
              autoComplete='off'
              className='code-input text-col_text00 bg-col_bg09 border-0 px-4 py-[12px] text-[16px] leading-[22px] placeholder:text-[16px] placeholder:text-[#999] focus:shadow-none '
              placeholder='请输入验证码'
            />
          </Form.Item>
        </div>
        <div className=''>
          <SendCodeBtn
            openAppealModal={handleAppealModal}
            getPhone={() => form.getFieldValue('phone')}
            isPhoneValid={phoneValid}
          />
        </div>
      </div>
      <div className='mt-3'>
        <div className='text-col_text02 flex select-none items-center'>
          <button
            type='button'
            className='outline-pri_1 mr-1.5 cursor-pointer'
            onClick={() => setChecked(!checked)}
          >
            {checked ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
          </button>
          <div className='text-[14px] leading-[20px]'>
            <span>我已阅读并同意&nbsp;</span>
            <span
              className='text-col_text06 cursor-pointer'
              onClick={() => openUrl(termsOfServiceUrl, true, '_blank')}
            >
              用户协议
            </span>
            <span>&nbsp;与&nbsp;</span>
            <span
              className='text-col_text06 cursor-pointer'
              onClick={() => openUrl(privacyPolicyUrl, true, '_blank')}
            >
              隐私政策
            </span>
          </div>
        </div>
      </div>
      <Button
        variant='black'
        onClick={onSubmit}
        disabled={!phoneValid || !checked}
        className='button mt-[24px] h-[48px] w-full rounded-[12px] text-[16px] font-medium md:h-[54px]'
      >
        立即登录
      </Button>
    </Form>
  );
};

export default LoginFormComponent;
